import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { reactive, computed, ref, onMounted } from 'vue'
import { customerListFormat } from '@/utils'
import { LbuSalesWorkReportParams, salesWorkList } from '@/api/yuntuSales/salesWorkReport'
import { getDeptInfo } from '@/api/common'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import CosStaticSelect from '@/components/CosStaticSelect'
import dayjs from 'dayjs'
import { formatAmount } from '../../../utils/format'

const __default__ = { name: 'DcCosLbuSalesWorkReport' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const deptInfo4List = ref([])
// const deptInfo5List = ref([])

const tableRef = ref()
const searchFrom = reactive<LbuSalesWorkReportParams>({
  queryType: 1,
  startTime: dayjs().startOf('month').format('YYYY/MM/DD 00:00:00'),
  endTime: dayjs().endOf('month').format('YYYY/MM/DD 23:59:59')
})

const fetch = (searchFrom: LbuSalesWorkReportParams, callBack: (res: any) => void) => {
  const params = customerListFormat(searchFrom) // 处理客户名称和客户编码的批量查询参数
  salesWorkList(params).then((res) => {
    callBack(res)
  })
}

const search = () => {
  tableRef.value.search()
}

const fetchDeptInfo = async () => {
  const res = await getDeptInfo({ appId: 'cos_lbu', rootId: '3853844' })
  deptInfo4List.value = res.data?.deptInfo[0]?.children
  deptInfo4List.value.forEach((item: any) => {
    if (item.children && item.children.length) {
      item.children.forEach((o: any) => {
        if (o.children) delete o.children
      })
    }
  })
}

onMounted(() => {
  fetchDeptInfo()
})

const dimensionEnum = [
  { value: 1, label: '区域' },
  { value: 2, label: '组', color: '#EF8D3C', desc: '' },
  { value: 3, label: '销售员', color: '#3FAC46', desc: '' }
]

const columns = computed(() => {
  const columns = [
    {
      title: '',
      width: 450,
      children: [
        { title: '区域', fixed: 'left', dataIndex: 'deptLevel4Name', width: 100 },
        { title: '部门组织', fixed: 'left', dataIndex: 'deptLevel5Name', width: 100 },
        { title: '销售员', fixed: 'left', dataIndex: 'employeeName', width: 100 }
      ]
    },
    // { title: '区域', fixed: 'left', dataIndex: 'deptLevel4Name' },
    // { title: '部门组织', fixed: 'left', dataIndex: 'deptLevel5Name' },
    // { title: '销售员', fixed: 'left', dataIndex: 'employeeName' },
    {
      title: '拜访量',
      width: 780,
      children: [
        { title: '登门拜访量（负责人）', dataIndex: 'sellerVisits', width: 160 },
        { title: '登门拜访量（更新人）', dataIndex: 'updatedVisits', width: 160 },
        { title: '非登门拜访量', dataIndex: 'nonVisits', width: 120 },
        { title: '总拜访量', dataIndex: 'totalVisits', width: 80 },
        { title: '人均登门拜访量', dataIndex: 'avgVisits', width: 140 },
        { title: '人均总拜访量', dataIndex: 'avgTotalVisits', width: 120 }
      ]
    },
    {
      title: '拜访占比',
      width: 480,
      children: [
        { title: '拜访成交客户占比', dataIndex: 'transactionRatio', width: 160 },
        { title: '拜访潜在客户占比', dataIndex: 'potentialRatio', width: 160 },
        { title: '拜访线索客户占比', dataIndex: 'clueRatio', width: 160 }
      ]
    },

    {
      title: '商机管理（总数）',
      width: 840,
      children: [
        { title: '预计月销售额', dataIndex: 'planSaleAmount', width: 120 },
        { title: '达成合作月销售额', dataIndex: 'saleAmount', width: 160 },
        { title: '现有机会转化率', dataIndex: 'saleChanceRate', width: 140 },
        { title: '总机会个数', dataIndex: 'totalSaleChance', width: 100 },
        { title: '机会月销售额', dataIndex: 'opportunityMonthlySales', width: 120 },
        { title: '机会个数', dataIndex: 'numberSaleChance', width: 80 },
        { title: '人均机会金额', dataIndex: 'avgSaleAmount', width: 120 },
        { title: '人均机会个数', dataIndex: 'avgSaleChance', width: 120 }
      ]
    },
    {
      title: '商机管理（本期创建）',
      width: 220,
      children: [
        { title: '新增月销售额', dataIndex: 'newSaleAmount', width: 120 },
        { title: '新增机会数', dataIndex: 'newSaleChance', width: 100 }
      ]
    }
  ]
  if (searchFrom.queryType && searchFrom.queryType < 3) {
    columns[0].children.splice(2, 1)
    columns[0].width = columns[0].width - 100
  }

  if (searchFrom.queryType && searchFrom.queryType < 2) {
    columns[0].children.splice(1, 1)
    columns[0].width = columns[0].width - 100
  }

  return columns
})

const exportRows = () => {
  const et = XLSX.utils.table_to_book(document.querySelector('#lbuSalesWorkReport'))
  const etout = XLSX.write(et, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  })
  try {
    FileSaver.saveAs(
      new Blob([etout], {
        type: 'application/octet-stream'
      }),
      '销售工作情况表.xlsx'
    )
  } catch (e) {
    console.log(e, etout)
  }
  return etout
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosCascader = _resolveComponent("CosCascader")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            bordered: "",
            dynamicColumnSetting: false,
            needPage: false,
            columns: columns.value,
            search: searchFrom,
            "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom) = $event)),
            onFetch: fetch,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "lbuSalesWorkReport",
            id: "lbuSalesWorkReport"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "维度" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: searchFrom.queryType,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.queryType) = $event)),
                        optionType: "button",
                        options: dimensionEnum,
                        onChange: search
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "区域" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CosStaticSelect), {
                        fieldNames: { label: 'label', value: 'id' },
                        options: deptInfo4List.value,
                        mode: "multiple",
                        value: searchFrom.deptLevel4List,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.deptLevel4List) = $event))
                      }, null, 8, ["options", "value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "部门组织" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosCascader, {
                        placeholder: "请选择",
                        type: "search",
                        options: deptInfo4List.value,
                        fieldNames: { label: 'label', value: 'id', children: 'children' },
                        appId: "cos_lbu",
                        multiple: "",
                        ids: searchFrom.deptLevel5List,
                        "onUpdate:ids": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.deptLevel5List) = $event))
                      }, null, 8, ["options", "ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "销售员" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: searchFrom.employeeNoList,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.employeeNoList) = $event)),
                        mode: "multiple",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.startTime,
                        "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.startTime) = $event)),
                        endTime: searchFrom.endTime,
                        "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: exportRows }, {
                default: _withCtx(() => [
                  _createTextVNode(" 导出 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_sales_work_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, text }) => [
              (['transactionRatio', 'potentialRatio', 'clueRatio', 'saleChanceRate'].includes(column.dataIndex))
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text === undefined || text === null ? '--' : (`${_unref(formatAmount)(text, 2)}%`)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})